"use strict";

import "./MultiSelect.css";
import React from "react";
import ReactSelect from "react-select";
import classnames from "classnames";

export default class MultiSelect extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			value: valueToOptions(this.props.options, this.props.defaultValue)
		};
	}
	
	setStateFromValue(value) {
		this.setState({
			value: value ? value : []
		}, () => this.props.onChange(optionsToValue(this.state.value)))
	}
	
	clear() {
		this.setStateFromValue([]);
	}
	
	render() {
		
		const className = classnames("MultiSelect", this.props.className);
		
		return (
			<div className={className} onClick={() => this.props.onClick()}>
				<ReactSelect
					multi
					value={this.state.value}
					placeholder={this.props.placeholder}
					options={this.props.options}
					disabled={this.props.disabled}
					onChange={value => this.setStateFromValue(value)}
					matchProp="label"
				/>
			</div>
		);
	}
	
}

function optionsToValue(options) {
	options = options || [];
	return options.map(o => o.value);
}

function valueToOptions(options, value) {
	options = options || [];
	value = value || [];
	return options.filter(o => value.includes(o.value));
}

MultiSelect.Option = React.PropTypes.shape({
	defaultValue:	React.PropTypes.string,
	label:			React.PropTypes.string
});

MultiSelect.propTypes = {
	options:		React.PropTypes.arrayOf(MultiSelect.Option),
	defaultValue:	React.PropTypes.arrayOf(React.PropTypes.string),
	disabled:		React.PropTypes.bool,
	onChange:		React.PropTypes.func,
	onClick:		React.PropTypes.func,
	placeholder:	React.PropTypes.string
};

MultiSelect.defaultProps = {
	options: [],
	defaultValue: [],
	disabled: false,
	onChange: value => {},
	onClick: () => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/MultiSelect/MultiSelect.jsx